// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "AnchorLinks-module--bx--text-truncate--end--DInm7";
export var bxTextTruncateFront = "AnchorLinks-module--bx--text-truncate--front--9U24X";
export var link = "AnchorLinks-module--link--xy7Z0";
export var list = "AnchorLinks-module--list--HqxCp";
export var listSmall = "AnchorLinks-module--list--small--5JrH-";
export var multipleColumns = "AnchorLinks-module--multiple-columns--nUAzJ";